/**
 * @generated SignedSource<<81065d20adba4a482079bc20a8c568ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type cCloudIntegrationSalesChannelDialogQuery$variables = Record<PropertyKey, never>;
export type cCloudIntegrationSalesChannelDialogQuery$data = {
  readonly currencies: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly ecommerceSettings: {
    readonly apiKey: string | null;
    readonly apiSecret: string | null;
    readonly currencyGlobalID: string;
    readonly ecommerceID: number;
    readonly ecommerceName: ECommerce;
    readonly remoteUrl: string | null;
    readonly username: string | null;
  } | null;
};
export type cCloudIntegrationSalesChannelDialogQuery = {
  response: cCloudIntegrationSalesChannelDialogQuery$data;
  variables: cCloudIntegrationSalesChannelDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apiKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apiSecret",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyGlobalID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currencies",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "cCloudIntegrationSalesChannelDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "cCloudIntegrationSalesChannelDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ]
  },
  "params": {
    "cacheID": "47e9dc569a8476d67b5fd00be04b8a72",
    "id": null,
    "metadata": {},
    "name": "cCloudIntegrationSalesChannelDialogQuery",
    "operationKind": "query",
    "text": "query cCloudIntegrationSalesChannelDialogQuery {\n  ecommerceSettings {\n    ecommerceID\n    ecommerceName\n    apiKey\n    apiSecret\n    remoteUrl\n    currencyGlobalID\n    username\n    id\n  }\n  currencies {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9a5b70145fcf9da5301c26a0e0e3c1a";

export default node;
